module.exports = __webpack_public_path__ + "static/media/cover_eng_7_8.b02c6506.jpg";